module.exports = __webpack_public_path__ + "img/Kingsland_University_wK_Dark_Vertical_resized.e41dfa00.png";